import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import React from "react";
import CustomApplicationState from "@WhiteCap/Store/Data/CustomApplicationState/CustomApplicationState";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { connect } from "react-redux";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";

{
    /* Start EC-544 [FE] Remove the Yellow Bar at the bottom and update the qty is in the cart icon */
}

// Mapping state to props for Redux state access
const mapStateToProps = (state: CustomApplicationState) => {
    const session = getSession(state);
    return {
        isAuthenticated: session.isAuthenticated,
    };
};

// Define the types for component props
type Props = ReturnType<typeof mapStateToProps> & WidgetProps;

// Interface for defining the styles for the component
export interface GuestRFQCartWrapperStyles {}

// Define default styles for the form and its components
export const guestRFQCartWrapperStyles: GuestRFQCartWrapperStyles = {};

const GuestRFQCartWrapper = ({ isAuthenticated, id }: Props) => {
    return (
        <StyledWrapper>
            {isAuthenticated ? (
                <Zone contentId={id} zoneName="User"></Zone>
            ) : (
                <Zone contentId={id} zoneName="Guest"></Zone>
            )}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(GuestRFQCartWrapper),
    definition: {
        displayName: "Guest RFQ Cart Wrapper",
        group: "Common",
    },
};

export default widgetModule;

{
    /* End EC-544 [FE] Remove the Yellow Bar at the bottom and update the qty is in the cart icon */
}